export default function (VirtualKeyboard) {
    return VirtualKeyboard.addLayout({
        code: 'NE-NP',
        name: 'Nepali ',
        normal: 'ञज्ञघङझछटठडढण(.्रत्रधभचतथगषयउृेबकमानजवपिसुशहअखदलफ,।र',
        shift: { 0: 'ञ्१२३४५६७८९०)ं्ोध्भ्च्त्थ्ग्क्षइएर्ैब्क्म्ँन्ज्व्प्ीस्ूश्ह्ऋख्द्ल्ः?श्ररू' },
        alt: { 1: '1234567890', 12: '+', 23: 'ऊ', 25: 'औ', 39: 'आ' }
    })
}
